import {
  addDoc,
  collection,
  CollectionReference,
  DocumentData,
  DocumentReference,
  serverTimestamp,
  Timestamp,
} from 'firebase/firestore'
import { MedicalReimbursementCreateSchema } from '../../database/validations/MedicalReimbursementCreate'
import { deleteObject, getDownloadURL, ref, StorageReference, uploadBytes } from 'firebase/storage'
import { db, storage } from '../../firebase/firebase'
import medicalReimbursementServiceConfigs from './configs'
import { MedicalReimbursementRaw } from '../../database/tables'
import DateHelper from '../../helpers/date-helper'

export default async function addMedicalReimbursement(
  data: MedicalReimbursementCreateSchema,
): Promise<DocumentReference<MedicalReimbursementRaw, DocumentData>> {
  return new Promise(async (resolve, reject) => {
    let supportingDocumentRef: StorageReference | null = null
    let supportingDocumentUrl: string | null = null

    try {
      if (!!data.supportingDocument) {
        const storageRef = ref(
          storage,
          `${medicalReimbursementServiceConfigs.collectionName}/${data.name.replaceAll(' ', '_')}-${new Date().getTime()}-${data.supportingDocument.name}`,
        )
        await uploadBytes(storageRef, data.supportingDocument).then(async snapshot => {
          supportingDocumentRef = snapshot.ref
          await getDownloadURL(snapshot.ref)
            .then(url => (supportingDocumentUrl = url))
            .catch(e => {
              throw e
            })
        })
      }

      const currCollection = collection(
        db,
        medicalReimbursementServiceConfigs.collectionName,
      ) as CollectionReference<MedicalReimbursementRaw>
      const docRef = await addDoc(currCollection, {
        approvalStatus: data.approvalStatus,
        name: data.name,
        email: data.email.toLowerCase(),
        serviceDate: Timestamp.fromDate(data.serviceDate),
        serviceDateString: DateHelper.toLocalDateString(data.serviceDate),
        reimbursementType: data.reimbursementType,
        vendor: data.vendor,
        description: data.description,
        totalAmountClaimed: {
          ...data.totalAmountClaimed,
          value: Number(data.totalAmountClaimed.value),
        },
        supportingDocumentRef: !!supportingDocumentRef ? (supportingDocumentRef as StorageReference).fullPath : null,
        supportingDocumentUrl,
        createdAt: serverTimestamp(),
        approvalUpdatedAt: null,
        approvalBy: null,
      })

      return resolve(docRef)
    } catch (e) {
      if (!!supportingDocumentRef) {
        await deleteObject(supportingDocumentRef)
      }

      return reject(e)
    }
  })
}
